import { useEffect, useMemo, useState, type ReactElement } from 'react';
import { usePageBreadcrumb, usePageSidebar } from '@/hooks';
import { sidebarItems } from './sidebar';

export const CatalogoCategoria = (): ReactElement => {
	const [title, setTitle] = useState<string>('Cargando...');

	// Simula fetch de Strapi
	useEffect(() => {
		const id = setTimeout(() => {
			setTitle('Buscador de notarios');
		}, 200);
		return () => clearTimeout(id);
	}, []);

	// Breadcrumb coherente con tus routes
	usePageBreadcrumb([{ label: 'El Colegio' }, { label: 'Categoria' }]);

	// Sidebar estable (memoizado)
	const sidebar = useMemo(() => sidebarItems, []);
	usePageSidebar(sidebar, true);

	return <div>Página Categoria</div>;
};
